module.exports = __webpack_public_path__ + "img/logo-at.2090bc70.svg";